<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Edit Sensor Details
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div
        v-if="sensorDetail.sensorLabel === 'Attic'"
        class="ac-body-sub-container"
      >
        <div class="ac-input-container">
          <div class="ac-input-header">
            Water Sensor is monitoring A/C?
          </div>
          <SACDropdown
            :options="acRelatedOptions"
            :value="sensorDetail.acRelated"
            field="acRelated"
            :change="changeSensorDetail"
          />
        </div>
      </div>
      <div
        v-if="sensorDetail.sensorLabel === 'Attic'"
        class="ac-body-sub-container"
      >
        <div class="ac-input-container">
          <div class="ac-input-header">
            Does this Water Sensor live in a Drain Pan?
          </div>
          <SACDropdown
            :options="drainPanTypes"
            :value="sensorDetail.drainPan"
            field="drainPan"
            :change="changeSensorDetail"
          />
        </div>
      </div>
      <div
        v-if="sensorDetail.sensorLabel === 'Attic'"
        class="ac-body-sub-container"
      >
        <div class="ac-input-container">
          <div class="ac-input-header">
            Is a Water Riser attached to this Water Sensor?
          </div>
          <SACDropdown
            :options="accessoryTypes"
            :value="accessory"
            field="accessory"
            :change="changeSensorDetail"
          />
        </div>
      </div>
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">
            Location:
          </div>
          <SACInput
            placeholder="Enter Location"
            field="location"
            :value="sensorDetail.location"
            :change="changeSensorDetail"
          />
        </div>
      </div>
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">
            Battery Last Replaced
          </div>
          <Datepicker v-model="selectedDate" />
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        v-if="isSmacAdmin"
        type="button"
        class="ac-form-button redbg"
        @click="removeSensor"
      >
        Delete Sensor
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="updateSensorLocation"
      >
        Update
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Updating Sensor Details"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'SensorDetailsForm',
  components: {
    SACInput,
    SACDropdown,
    Datepicker,
    ProcessOverlay,
  },
  props: {
    selectedSensor: Object,
    toggleModal: Function,
  },
  data() {
    const sensorDetail = _.cloneDeep(this.selectedSensor);
    return {
      sensorDetail,
      acRelatedOptions: [{
        label: 'Yes',
        value: true,
      }, {
        label: 'No',
        value: false,
      }],
      accessoryTypes: [{
        label: 'Yes',
        value: 'Riser',
      }, {
        label: 'No',
        value: '',
      }],
      drainPanTypes: [{
        label: 'Yes',
        value: 'Y',
      }, {
        label: 'No',
        value: 'N',
      }],
      processing: false,
    };
  },
  computed: {
    ...mapGetters([
      'isSmacAdmin',
    ]),
    selectedDate: {
      get() {
        const date = this.sensorDetail.batteryUpdate || this.sensorDetail.creationDate;
        return new Date(date);
      },
      set(value) {
        this.changeSensorDetail('batteryUpdate', value);
      },
    },
    accessory: {
      get() {
        const { accessory } = this.sensorDetail;
        if (accessory && accessory === 'No') {
          return '';
        }
        return this.sensorDetail.accessory ?? '';
      },
      set(value) {
        this.changeSensorDetail('accessory', value);
      },
    },
  },
  methods: {
    changeSensorDetail(field, value) {
      this.sensorDetail = { ...this.sensorDetail, [field]: value };
    },
    async updateSensorLocation() {
      this.processing = true;

      try {
        const {
          serialNumber, location, drainPan, acRelated, batteryUpdate, uid,
        } = this.sensorDetail;

        const formattedBatteryUpdate = moment(batteryUpdate).toISOString();

        const updateData = {
          serialNumber,
          location,
          accessory: this.accessory === '' ? 'No' : 'Riser',
          drainPan,
          acRelated,
          batteryUpdate: formattedBatteryUpdate,
          uid,
        };

        const res = await this.$store.dispatch('updateSensor', updateData);

        if (res) {
          this.toggleModal(false);
        }
      } catch (error) {
        console.error('Error updating sensor location:', error);
      } finally {
        this.processing = false;
      }
    },
    async removeSensor() {
      const {
        sensorType,
      } = this.sensorDetail;
      if (sensorType?.toLowerCase().includes('temp')
        || sensorType?.toLowerCase().includes('pressure')
      ) {
        this.toggleModal(true, 'delete-warning');
      } else {
        this.processing = true;
        try {
          await this.$store.dispatch('removeSensor');
          this.toggleModal(false);
        } catch (err) {
          console.error(err);
        }
        this.processing = false;
      }
    },
  },
};
</script>
<style lang="scss">

.remove-sensor-button {
  margin-top: 15px;
  width: 150px;
  border: 1px solid $PUNCH;
  color: $PUNCH;
  font-size: 1rem;
}
</style>
